import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@app/core/config/config.service';
import { AuthService } from '@app/core/guards/auth.service';
import { HttpService } from '@app/core/http/http.service';

@Injectable({
    providedIn: 'root'
})
export class ProgressService extends HttpService {

    constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
        super(http, config, authService, 'progress');
    }


    getProgress(requestId: string): Observable<number> {
        return this.getById<number>(requestId);
    }
}
